import cogoToast from 'cogo-toast';
import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../Containers/Config/index';
import apiCall from '../../../apiCall.js';

import { VIEW_PRICING, VIEW_PRICING_SUCCESS, VIEW_PRICING_ERROR } from './../../../actionType.js';

function* viewPricing({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { type, configurationId } = payload?.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/benefit-type/airport-transfer/${type}/view/${configurationId}`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success('File uploaded successfully');
      yield put({
        type: VIEW_PRICING_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({ type: VIEW_PRICING_ERROR, payload: response?.data?.message });
    }
  } catch (error) {
    yield put({ type: VIEW_PRICING_ERROR, payload: error });
  }
}

export function* watchviewPricing() {
  yield takeEvery(VIEW_PRICING, viewPricing);
}

function* viewPricingSaga() {
  yield all([fork(watchviewPricing)]);
}

export default viewPricingSaga;
